import { RestaurantTransactionListFull } from "@/screens/restaurants/details/restaurant.transaction.list";
import { Stack, useLocalSearchParams } from "expo-router";

export default function FullList() {
  const { orgId } = useLocalSearchParams<{ orgId: string }>();

  return (
    <>
      <Stack.Screen options={{ title: "Transactions" }} />
      <RestaurantTransactionListFull organizationId={orgId} />
    </>
  );
}
